import { Button } from "risa-oasis-ui_v2";

interface PocConfigurationFooterProps {
  dirtyCount: number;
  saving: boolean;
  onSave: () => void;
}

/**
 * Footer actions for the POC configuration page.
 */
const PocConfigurationFooter = ({
  dirtyCount,
  saving,
  onSave,
}: PocConfigurationFooterProps) => {
  return (
    <div className="poc-configuration__footer flex flex-shrink-0 items-center justify-end gap-2 border-t border-primaryGray-16 pt-3">
      <Button
        buttonType="primary"
        size="medium"
        disabled={dirtyCount === 0 || saving}
        onClick={onSave}
      >
        {saving ? "Saving…" : "Save Changes"}
      </Button>
    </div>
  );
};

export default PocConfigurationFooter;
